/**
 * Куда вести кнопку «Подробнее» в истории.
 *
 * ⚠️ ТОЛЬКО ВНУТРЕННИЕ ПУТИ `/app/…` (решение владельца 14.09.2026, Apple 3.1.3(f)). Раньше
 * кнопка открывала `link_url` из базы в новом окне — любой адрес, который впишет сотрудник в
 * админке: сайт школы, Instagram, WhatsApp. Внешний сайт из приложения Apple читает как обход
 * правил. Внешний адрес теперь просто не показывается — кнопки нет.
 *
 * Возвращает путь для перехода внутри приложения или `null`.
 */
export function internalAppPath(url?: string | null): string | null {
  const s = (url ?? '').trim();
  // Только относительный путь нашего кабинета. `//evil.com` — адрес с чужим доменом без схемы,
  // `/app\…` и `/app/../` — попытки выйти за пределы кабинета.
  if (!/^\/app(\/|$|\?|#)/.test(s)) return null;
  if (s.startsWith('//') || s.includes('\\') || /(^|\/)\.\.(\/|$)/.test(s)) return null;
  return s;
}
